import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment-timezone';
import { FormControl, Grid } from '@mui/material';
import { DateTimePicker, TimePicker } from '@mui/x-date-pickers-pro';
import LocalizedDatePicker from '../../../../custom-widgets/LocalizedDatePicker';

const pickerMap = {
    datetime: DateTimePicker,
    time: TimePicker,
};

const Interval = ({ name, type, props }) => {
    const { control, watch } = useFormContext();
    const Picker = pickerMap[type] ?? TimePicker;

    const minEnd = watch(`${name}.start`);

    const sanitizeMoment = (value) => {
        if (!value) return null;
        return moment.isMoment(value) ? value : moment(value);
    };

    return (
        <FormControl fullWidth style={{ margin: '8px 0' }}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Controller
                        control={control}
                        name={`${name}.start`}
                        render={({ field }) => (
                            <LocalizedDatePicker
                                Picker={Picker}
                                slotProps={{
                                    textField: {
                                        InputLabelProps: { shrink: true },
                                        required: true,
                                    },
                                }}
                                label="Start Time"
                                sx={{ width: '100%' }}
                                {...field}
                                value={sanitizeMoment(field.value)}
                                {...props}
                                // wrap
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        control={control}
                        name={`${name}.end`}
                        render={({ field }) => (
                            <LocalizedDatePicker
                                Picker={Picker}
                                slotProps={{
                                    textField: {
                                        InputLabelProps: { shrink: true },
                                        required: true,
                                    },
                                }}
                                label="End Time"
                                sx={{ width: '100%' }}
                                minDateTime={sanitizeMoment(minEnd)}
                                {...field}
                                value={sanitizeMoment(field.value)}
                                {...props}
                                // wrap
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </FormControl>
    );
};

export default Interval;
